import { render } from "./AreasList.vue?vue&type=template&id=ce3d1f36&scoped=true"
import script from "./AreasList.vue?vue&type=script&lang=js"
export * from "./AreasList.vue?vue&type=script&lang=js"

import "./AreasList.vue?vue&type=style&index=0&id=ce3d1f36&scoped=true&lang=css"

import exportComponent from "/home/yandry/Downloads/s3-integration-app-web-prod(1)/s3-integration-app-web-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3d1f36"]])

export default __exports__